import { cloneDeep } from "lodash";
import React, { useState } from "react";
import Modal, { Styles } from "react-modal";
const assessmentCarSvg = require("../../../src/assets/images/svg/assessment-car.svg").default;
const comapassSvg = require("../../../src/assets/images/svg/compass.svg").default;
const assessmentTickSvg = require("../../../src/assets/images/svg/assessment-tick.svg").default;

const modalStyles = {
  content: {
    height: "203px",
    width: "399px",
    margin: "auto",
    position: "absolute",
    top: "0%",
    left: "0%",
    right: "0%",
    bottom: "0%",
    background: "#fff",
    borderRadius: "5px",
    outline: "none",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.5)",
  },
};

const compassSelectionItemsList = [
  { id: 1, value: "Own another vehicle", state: false },
  { id: 2, value: "I prefer ride-sharing services", state: false },
  { id: 3, value: "Not sure if I’m eligible", state: false },
  { id: 4, value: "I prefer public transportation", state: false },
  { id: 5, value: "Temporary circumstances", state: false },
  { id: 6, value: "Others", state: false },
];

export interface IAssessmentModalProps {
  modalState: number;
  bookingIsLoading: boolean;
  handleModalButtonClick: (action: string) => void;
}

const AssessmentDialog = ({ modalState, handleModalButtonClick, bookingIsLoading }: IAssessmentModalProps) => {
  const [selectionItems, setSelectionItems] = useState(compassSelectionItemsList);

  if (modalState === 2) {
    modalStyles.content.height = "212px";
  } else if (modalState === 3) {
    modalStyles.content.height = "267px";
  } else {
    modalStyles.content.height = "203px";
  }

  const handleSelectItem = (id: number) => {
    const tempSelectionItems = cloneDeep(compassSelectionItemsList);
    const index = tempSelectionItems.findIndex((item) => item.id === id);
    tempSelectionItems[index].state = true;
    setSelectionItems(tempSelectionItems);
  };

  const isButtonDisabled = () => {
    const isSelected = selectionItems.find((item) => item.state);
    if (!isSelected) {
      return "disabled-btn";
    }
    return "";
  };

  const renderModalBody = () => {
    return (
      <>
        {modalState === 1 && (
          <div className="modal-bot-sec">
            <div className="border-compass"></div>
            <img src={comapassSvg} className="compass-image" alt="Compass image" />
            <div className="compass-main">
              <p className="compass-offers">
                <img src={assessmentTickSvg} className="assessment-tick" alt="Assessment Tick" />
                $0 excess
              </p>
              <p className="compass-offers">
                <img src={assessmentTickSvg} className="assessment-tick" alt="Assessment Tick" />
                Pick-up and drop-off at repairer
              </p>
              <p className="compass-offers">
                <img src={assessmentTickSvg} className="assessment-tick" alt="Assessment Tick" />
                Coverage for the duration of repairs
              </p>
            </div>
          </div>
        )}
        {modalState === 2 && (
          <div className="modal-bot-sec">
            <p className="state-2-text">
              Someone from Compass wil get in <br />
              touch with you shortly
            </p>
          </div>
        )}
        {modalState === 3 && (
          <div className="modal-bot-sec">
            <div className="selection-main">
              {selectionItems.map((item) => {
                return (
                  <div onClick={() => handleSelectItem(item.id)} className={`selection-item ${item.state && "selected-item"}`}>
                    {item.value}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </>
    );
  };

  const renderModalFooter = () => {
    return (
      <>
        {modalState === 1 && (
          <div className="assessment-footer">
            {bookingIsLoading ? (
              <p className="btn-assessment-footer">
                Please wait...
              </p>
            ) : (
              <p onClick={() => handleModalButtonClick("BOOK_IN")} className="btn-assessment-footer">
                Book in
              </p>
            )}
            <p onClick={() => {
              if(!bookingIsLoading) {
                handleModalButtonClick("NOT_INTERESTED")
              }
            }} className="btn-assessment-footer">
              Not interested
            </p>
          </div>
        )}
        {modalState === 2 && (
          <div className="assessment-footer">
            <div onClick={() => handleModalButtonClick("CONTINUE")} className="btn-modal-continue">
              Continue
            </div>
          </div>
        )}
        {modalState === 3 && (
          <div className="assessment-footer">
            <div onClick={() => handleModalButtonClick("NOT_INTERESTED_CONTINUE")} className={`btn-modal-continue ${isButtonDisabled()}`}>
              Continue
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <Modal
      className={"widthResponsive"}
      isOpen={true}
      //   onRequestClose={this.closeModal}
      style={modalStyles as Styles}
    >
      <div className="assessment-modal-container">
        <div className="modal-top-sec">
          <div className="top-description-container">
            <p className="top-title">
              Get a replacement car <br />
              at no cost to you
            </p>
            <p className="top-text">Based on your answers you are eligible for a hire car</p>
          </div>
          <img src={assessmentCarSvg} className="assessment-car-image" alt="Assesment Car image" />
        </div>
        {renderModalBody()}
        {renderModalFooter()}
      </div>
    </Modal>
  );
};

export default AssessmentDialog;
